let config = {};

config.baseURL = 'https://api.projetos.innovareti.com.br/api/v1/';
config.normalURL = 'https://api.projetos.innovareti.com.br/';

//config.baseURL = 'http://localhost:8000/api/v1/';
//config.normalURL = 'http://localhost:8000/';

export default config



// WEBPACK FOOTER //
// ./src/config/production.js